<template>
  <div class="prize">
    <div class="container">
      <ui-box class="ui-box-prize">
        <template v-slot:nav>
          <div class="title"></div>
          <!-- <div class="title">最终奖金预测 ￥{{ expectedCount }}</div> -->
          <div class="right-box">
            <div class="modal-btn prize" @click="handleShowPrize">
              <i></i><span>奖金规则</span>
            </div>
            <div class="modal-btn rule" @click="handleShowRule">
              <i></i><span>完整赛制</span>
            </div>
          </div>
        </template>
        <template v-slot:container>
          <div
            class="inner-container"
            :style="{
              'background-image': `url(${$lg(config, 'prize', '')})`
            }"
          >
            <div class="rates">
              <div class="sha-current">当前奖金</div>
              <div class="current">当前奖金</div>

              <div class="sha-expected">
                <span>￥</span>{{ currentCount.toLocaleString() }}
              </div>
              <div class="expected">
                <span>￥</span>{{ currentCount.toLocaleString() }}
              </div>
            </div>
          </div>
        </template>

        <modal-rule ref="rule" />
        <modal-prize ref="prize" />
      </ui-box>
      <!-- <div class="boy"></div>
      <div class="girl"></div>
      <div class="boy-shadow"></div>
      <div class="girl-shadow"></div> -->
      <div></div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import * as api from '@/service/index'
import UiBox from '@/components/ui-box'
import ModalRule from './modal/rule'
import ModalPrize from './modal/prize'

export default {
  components: { UiBox, ModalRule, ModalPrize },

  inject: ['json_config'],
  data() {
    return {
      expectedCount: 0,
      currentCount: 0,
      record: false,
      isUpdating: false,
      closePrize: false
    }
  },
  computed: {
    ...mapState(['token']),
    config() {
      return this.json_config()
    }
  },
  created() {
    
    // this.handlePrize()
    // this.updatePrize()
  },
  methods: {
    handleShowRule() {
      this.$refs.rule.showModal()
    },

    handleShowPrize() {
      this.$refs.prize.showModal()
    },
    async handlePrize() {
      try {
        const res = await api.reqPrize()
        if (res.status === 200) {
          const { expected_count, current_count } = res.data
          this.expectedCount = expected_count
          this.currentCount = current_count
        }
      } catch (err) {
        console.log(err)
      }
    },
    // updatePrize() {
    //   if (!this.isUpdating) {
    //     this.isUpdating = true
    //     if (this.timer) {
    //       clearInterval(this.timer)
    //     }
    //     this.timer = setInterval(() => {
    //       if (this.closePrize) {
    //         return
    //       }
    //       //  自动记录 报名结束后开启
    //       // this.handlePrize()
    //       this.isUpdating = false
    //     }, 60000)
    //   }
    // }
  },
  beforeDestroy() {
    clearInterval(this.timer)
    this.closePrize = true
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/prize/index';
</style>